export enum QuickAccessPermissions {
	CreateCommercialProposal = "CREATE_COMMERCIAL_PROPOSAL",
	CreateReceipt = "CREATE_RECEIPT",
	Both = "BOTH",
	NotAllowed = "NOT_ALLOWED"
}
